import {CountryHash} from 'typescript/interfaces/CountryHash';
import {PubBeer} from 'typescript/models/PubBeer';
import './TemplateBeer2.scss';

interface IProps {
  beer: PubBeer;
  countryHash: CountryHash;
  showPrice?: boolean;
}

export default function TemplateBeer2({beer, countryHash, showPrice = true}: IProps) {
  const {beer_logo, style, beer_name, brewery_name, abv, ibu, country, beer_variants} = beer.attributes;

  return (
    <div
      className={`template-beer-2 ${!showPrice ? 'template-beer-2--no-price' : ''}`}
      aria-label="Template beer display"
    >
      <div className="template-beer-2__style" aria-label="Beer name">
        <h3>{style}</h3>
      </div>
      <div className="template-beer-2__stats" aria-label="Beer stats">
        <figure className="template-beer-2__logo">
          {/* Must use backgroundImage since html2canvas doesn't support object-fit property */}
          <div
            className="template-beer-2__img"
            style={{
              backgroundImage: `url("${beer_logo || 'images/post-beer-placeholder.png'}")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </figure>
        <div className="template-beer-2__info" aria-label="Beer info">
          <div className="template-beer-2__name">
            <h4>{beer_name}</h4>
            <span>by {brewery_name}</span>
          </div>
          {showPrice && (
            <div className="template-beer-2__prices">
              {beer_variants.map((variant) => (
                <div className="template-beer-2__price" key={variant.id}>
                  <span>{variant.amount} L</span>
                  <span>{Math.trunc(+variant.price)}</span>
                  <span>{variant.currency}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="template-beer-2__country" aria-label="Beer country">
          <h5 className="template-beer-2__abv">
            ABV
            <span>
              {+parseFloat(abv).toFixed(1)} <small>%</small>
            </span>
          </h5>
          <h5 className="template-beer-2__flag">
            ORIGIN <img src={countryHash[country]?.flag} alt="Country flag" />
          </h5>
          <h5 className="template-beer-2__ibu">
            IBU <span>{+parseFloat(ibu).toFixed(1)}</span>
          </h5>
        </div>
      </div>
    </div>
  );
}
